import { LOGIN, LOGOUT, SIGNUP } from 'Constants'

export default function(
  state = localStorage.getItem('customerkey') !== null,
  action
) {
  switch (action.type) {
    case LOGIN:
      return localStorage.getItem('customerkey') !== null
    case SIGNUP:
      return localStorage.getItem('customerkey') !== null
    case LOGOUT: {
      // Save the aws-waf-token before clearing
      const awsWafToken = localStorage.getItem('aws-waf-token')
      localStorage.clear()
      // Restore the aws-waf-token
      if (awsWafToken) {
        localStorage.setItem('aws-waf-token', awsWafToken)
      }
      return false
    }
    default:
      return state
  }
}
